import { ApplicationClaim } from "../models";

export class Application {
    id: string;
    name: string;
    description: string;
    url: string;
    isAccessible: string;
    applicationStatusCode: string;
    notification: string;
    claims: Array<ApplicationClaim>;
}


// WEBPACK FOOTER //
// ./src/app/models/application.ts